// This file was generated by the build-public-api.ts script
export * from './components/promotion-detail/promotion-detail.component';
export * from './components/promotion-list/promotion-list.component';
export * from './marketing.module';
export * from './marketing.routes';
export * from './providers/routing/promotion-resolver';
